import { render } from "./App.vue?vue&type=template&id=09a167fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=09a167fa&lang=css"

import exportComponent from "../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__